import * as S from "./styles.ts";
import { ColorKey } from "@template/theme/types/color.type.ts";

export interface ILoadingSpinnerProps {
  width?: number | string;
  height?: number | string;
  color?: ColorKey | "white";
}

const LoadingSpinner = ({
  width,
  height,
  color,
  ...props
}: ILoadingSpinnerProps) => (
  <S.LoadingSpinnerContainer
    $color={color}
    style={{
      width: width,
      height: height,
    }}
    {...props}
  />
);

export default LoadingSpinner;
